import userInfo from 'hub-http/userInfo';
export function fetchUserInfo() {
  return userInfo();
}